import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetSelectedAssignee} from '../../../../store/data/refinements/refinementsSelectors';
import {
  CellsPanelPageSelector,
  makeGetCellsPanelCurrentPage,
} from '../../../../store/panels/cells/cellsPanelSelectors';
import {RefinedInboxParameters} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {
  findSelectedRefinementFromProps,
  inboxParametersHasUnassignedFilter,
} from '../../../../store/panels/inboxes/parameters/inboxesParametersHelpers';
import {CellsPanelId} from '../../../../store/panels/panelStateBase';
import {EmptyRefinedInboxes} from './emptyRefinedInboxes';

/*
 * Props.
 */

interface EmptyInboxesContainerProps {
  panelId: CellsPanelId;
  parameters: RefinedInboxParameters;
}

/*
 * Selectors.
 */

function getCellsPanelId(_state: AppState, props: EmptyInboxesContainerProps) {
  return props.panelId;
}

function makeGetSelectedRefinement(getPage: CellsPanelPageSelector<EmptyInboxesContainerProps>) {
  return createSelector([getPage], (page) => findSelectedRefinementFromProps(page.parameters, page));
}

const makeGetHasUnassignedFilter = (getPage: CellsPanelPageSelector<EmptyInboxesContainerProps>) =>
  createSelector([getPage], (page) => {
    const {parameters} = page;
    return inboxParametersHasUnassignedFilter(parameters);
  });

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<EmptyInboxesContainerProps>()(() => {
  const getCellsPanelCurrentPage = makeGetCellsPanelCurrentPage(getCellsPanelId);
  const getSelectedRefinement = makeGetSelectedRefinement(getCellsPanelCurrentPage);
  const getHasUnassignedFilter = makeGetHasUnassignedFilter(getCellsPanelCurrentPage);
  return {
    page: getCellsPanelCurrentPage,
    panelId: getCellsPanelId,
    selectedAssignee: makeGetSelectedAssignee(getSelectedRefinement),
    hasUnassignedFilter: getHasUnassignedFilter,
  };
});

export const EmptyRefinedInboxesContainer = connect(mapStateToProps)(EmptyRefinedInboxes);
